// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3kFf2","headerWrapper":"styles_headerWrapper__2ZUSR","button":"styles_button__3v1F3"};